@if ((toasts|async)!.length > 0) {
  <div class="toast-container absolute right-7 flex flex-col gap-y-2 z-10">
    @for (toast of toasts|async; track toast) {
      <div class="rounded-md p-4 transition-opacity" data-toast-container [ngClass]="['bg-'+toast.color+'-50', toast.hideClass]">
        <div class="flex">
          <div class="shrink-0">
            @switch (toast.severity) {
              @case (severity.WARNING) {
                <ng-icon name="heroExclamationTriangle" size="1.2rem" [ngClass]="'text-'+toast.color+'-400'"></ng-icon>
              }
              @case (severity.INFO) {
                <ng-icon name="heroInformationCircle" size="1.2rem" [ngClass]="'text-'+toast.color+'-400'"></ng-icon>
              }
              @case (severity.DANGER) {
                <ng-icon name="heroXCircle" size="1.2rem" [ngClass]="'text-'+toast.color+'-400'"></ng-icon>
              }
              @case (severity.SUCCESS) {
                <ng-icon name="heroCheckCircle" size="1.2rem" [ngClass]="'text-'+toast.color+'-400'"></ng-icon>
              }
            }
          </div>
          <div class="ml-3">
            @if (toast.text.title) {
              <h3 class="text-sm mb-2 font-medium" [ngClass]="'text-'+toast.color+'-800'" data-toast-title>
                {{toast.text.title}}
              </h3>
            }
            <div class="text-sm" [ngClass]="'text-'+toast.color+'-700'" data-toast-body>
              {{toast.text.body}}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
